import { Injectable } from '@angular/core';
import { Theme, defaultTheme, engageHubTheme, darkTheme } from './theme';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly THEME_KEY = 'ctn_theme_preference';

  setDefaultTheme(): void {
    this.setActiveTheme(defaultTheme);
  }

  setEngageHubTheme(): void {
    this.setActiveTheme(engageHubTheme);
  }

  setDarkTheme(): void {
    this.setActiveTheme(darkTheme);
  }

  setActiveTheme(theme: Theme): void {
    Object.keys(theme.properties).forEach((property) => {
      document.documentElement.style.setProperty(property, theme.properties[property]);
    });
  }

  isDarkMode(userId: string): boolean {
    return localStorage.getItem(`${this.THEME_KEY}_${userId}`) === 'dark';
  }

  applyUserTheme(userId: string, baseThemeIsEngageHub = false): void {
    if (this.isDarkMode(userId)) {
      this.setDarkTheme();
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
      if (baseThemeIsEngageHub) {
        this.setEngageHubTheme();
      } else {
        this.setDefaultTheme();
      }
    }
  }

  toggleDarkMode(userId: string, baseThemeIsEngageHub = false): boolean {
    const isDark = !this.isDarkMode(userId);
    localStorage.setItem(`${this.THEME_KEY}_${userId}`, isDark ? 'dark' : 'light');
    this.applyUserTheme(userId, baseThemeIsEngageHub);
    return isDark;
  }
}
